var map = {
	"./bg-standby-green.svg": 8358,
	"./fingerprint.svg": 3303,
	"./folder-open-solid.svg": 9072,
	"./hand-pointer.svg": 6734,
	"./icon-open-menu.svg": 3345,
	"./loader.svg": 3960,
	"./location-pin.svg": 5494,
	"./logo-black.svg": 3382,
	"./logo-icon.svg": 670,
	"./phone.svg": 7283,
	"./select-filter.svg": 428,
	"./split-arrow.svg": 8767,
	"./store-logo.svg": 7868,
	"./warning.svg": 9879
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5019;